(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powerlete-help-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initHelpCardAnimations = () => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const panels = document.querySelectorAll('.pw-help__panel');
    if (!panels.length) return;
    panels.forEach(panel => panel.classList.add('will-animate'));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('will-animate');
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );
    panels.forEach(panel => io.observe(panel));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHelpCardAnimations);
  } else {
    initHelpCardAnimations();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powerlete-returns-policy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initStepAnimations = () => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const steps = document.querySelectorAll('.pw-returns__step[data-step-index]');
    if (!steps.length) return;
    steps.forEach(step => step.classList.add('will-animate'));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const delay = Number(entry.target.dataset.stepIndex) * 120;
          setTimeout(() => {
            entry.target.classList.remove('will-animate');
            entry.target.classList.add('is-visible');
          }, delay);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    steps.forEach(step => io.observe(step));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStepAnimations);
  } else {
    initStepAnimations();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
